/**
 *
 * @author Matthew Rawson @ 20/06/2018 11:41
 * @description
 * @notes
 */
import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import styled, {css} from "styled-components"
import {isEmpty, isFunction} from "lodash"

import id from "@irati/utils/id"
import Loading from "@irati/ui/src/Loading"
import Icon from "@irati/ui/src/Icon"
import {injectRoute} from "@irati/utils/helpers/routing"
import {RouterLink} from "@irati/ui/src/Link"
import {perkbox} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {Label1} from "@irati/ui/src/Labels"
import {label1} from "@irati/ui/src/Labels/css/labels"
import {FormattedMessage} from "@irati/utils/lang"


const BreadcrumbWrapper = styled.div`
  min-height: 55px;
  padding: ${padding.base} 0;

  ${minWidthMedia.tablet`
    min-height: 55px;
    padding: ${padding.base} 0;
  `}
`

const commonCss = css`
  display: inline-block;
  margin-right: 10px;
`

const ActiveRouterLink = styled(RouterLink)`
  ${commonCss}
  ${label1}
  color: ${perkbox.blue};
`
const Title = styled(Label1)`
  ${commonCss}
`

const StyledIcon = styled(Icon)`
  margin-bottom: 2px;
  margin-right: 7px;
  ${({reverse}) => reverse && `
    transform: rotate(180deg);
  `}
`

class Breadcrumbs extends Component {
  static propTypes = {
    crumbs: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      values: PropTypes.object,
      url: PropTypes.string,
      onClick: PropTypes.func
    })),
    match: PropTypes.object,
    load: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool
    ]),
    reverseArrows: PropTypes.bool
  }
  static defaultProps = {
    crumbs: [],
    match: {},
    load: null,
    reverseArrows: false
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("Breadcrumbs", this.props)
    const {crumbs, match: {params}, load, reverseArrows} = this.props

    /** No navigation if no crumbs provided */
    if (isEmpty(crumbs)) return null

    return (
      <BreadcrumbWrapper id={idNamespace}>
        <Loading load={load} Loader={() => null} Error={() => null}>
          {crumbs.map((crumb, index) => {
            const isLast = index === crumbs.length - 1

            const {title, url, onClick, values} = crumb

            if (isLast) {
              return (
                <Title key={index}>
                  <FormattedMessage id={title} values={values} />
                </Title>
              )
            }

            return (
              <Fragment key={index}>
                <ActiveRouterLink uppercase bold to={injectRoute(url, params)} async={isFunction(onClick)} onClick={onClick}>
                  <FormattedMessage id={title} values={values} />
                </ActiveRouterLink>
                <StyledIcon icon="angleRight" size={12} reverse={reverseArrows} />
              </Fragment>
            )
          })}
        </Loading>
      </BreadcrumbWrapper>
    )
  }
}

export default Breadcrumbs
